import { api } from './client'

export const reportApi = {
  /** Fetch JSON report data for the authenticated user. */
  get: (userId, token, days = 30) =>
    api.get(`/report/${userId}?days=${days}`, token),

  /** Download PDF report. Returns a Blob.
   *
   *  Surfaces the backend's structured ``{detail: ...}`` payload when
   *  the request fails (501 when xhtml2pdf is unavailable, 500 on
   *  conversion error). Caller renders ``err.message`` in the error
   *  banner. Previously this threw a generic "PDF download failed"
   *  even when the server explained itself.
   */
  getPdf: async (userId, token, days = 30) => {
    const BASE = (import.meta.env.VITE_API_BASE_URL || '') + '/api/v1'
    const res = await fetch(`${BASE}/report/${userId}?format=pdf&days=${days}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    if (!res.ok) {
      let detail = ''
      try {
        const body = await res.json()
        detail = body?.detail || ''
      } catch {
        // Non-JSON body (rare) — fall through to a generic message.
      }
      throw new Error(detail || `PDF download failed (${res.status})`)
    }
    return res.blob()
  },

  /** Create a shareable link (7-day expiry).
   *
   *  ``includeJournal`` is the per-share consent choice from the modal.
   *  Narrow-only: the backend ANDs it with research_consent, so true
   *  never widens beyond what the user has already consented to.
   */
  share: (userId, token, days = 30, includeJournal = true) =>
    api.post(`/report/${userId}/share?days=${days}`, { include_journal: includeJournal }, token),

  /** List ACTIVE share links (not expired, not revoked). */
  listShares: (userId, token) =>
    api.get(`/report/${userId}/shares`, token),

  /** Revoke a share link — the public URL 410s immediately. */
  revokeShare: (userId, shareId, token) =>
    api.delete(`/report/${userId}/shares/${shareId}`, token),
}
